<template>
  <section>
    <footer class="main-footer">
      <div class="float-right hidden-xs">
        <b>Version</b> 1.0
      </div>
      <strong>Copyright &copy; {{new Date().getFullYear()}} <a href="#">{{appName}}</a>.</strong> All rights
      reserved.
    </footer>
  </section>
</template>

<script>
  export default {
    methods: {
      changeColor(payload) {
        let mySkins = [
          'skin-blue',
          'skin-black',
          'skin-red',
          'skin-yellow',
          'skin-purple',
          'skin-green',
          'skin-blue-light',
          'skin-black-light',
          'skin-red-light',
          'skin-yellow-light',
          'skin-purple-light',
          'skin-green-light'
        ];
        $.each(mySkins, function (i) {
          $('body').removeClass(mySkins[i]);
        });
        $('body').addClass(payload);
        this.$store.commit('CHANGE_USER_SKIN', payload);
        this.getLayout();
      }
    }
  };
</script>

<style>
  aside::before {
    display: none !important;
  }
</style>